export enum ExclamationCircleIconVariant {
  warning = "warning",
  error = "error",
}

const getColor = (variant: ExclamationCircleIconVariant): string => {
  switch (variant) {
    case ExclamationCircleIconVariant.warning:
      return "#FBBC05";
    case ExclamationCircleIconVariant.error:
      return "#EA526F";
  }
};

interface ExclamationCircleIconProps {
  variant: ExclamationCircleIconVariant;
  filled?: boolean;
}

const ExclamationCircleIcon = ({
  variant,
  filled = false,
}: ExclamationCircleIconProps) => {
  const color = getColor(variant);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      data-test-alert-circle-icon="true"
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        fill={filled ? "#fafafa" : "none"}
        stroke={!filled ? color : "none"}
        strokeWidth="2"
      />

      {filled ? (
        <path
          d="M12 21C17.5228 21 22 16.5228 22 11C22 5.47715 17.5228 1 12 1C6.47715 1 2 5.47715 2 11C2 16.5228 6.47715 21 12 21ZM12 12.9167C11.5487 12.9167 11.1193 12.6107 11.0641 12.1649L10.5663 7.62209C10.4747 6.84126 11.138 6.20833 11.9188 6.20833H12.0812C12.862 6.20833 13.5253 6.84126 13.4337 7.62209L12.9359 12.1649C12.8807 12.6107 12.4513 12.9167 12 12.9167ZM12 16.5C11.3094 16.5 10.75 15.9406 10.75 15.25C10.75 14.5594 11.3094 14 12 14C12.6906 14 13.25 14.5594 13.25 15.25C13.25 15.9406 12.6906 16.5 12 16.5Z"
          fill={color}
        />
      ) : (
        <>
          <path d="M11 7H13V13H11V7Z" fill={color} />
          <path d="M11 15H13V17H11V15Z" fill={color} />
        </>
      )}
    </svg>
  );
};

export default ExclamationCircleIcon;
